import AsyncRoute from 'components/AsyncRoute'
import { Redirect, Switch } from 'react-router-dom'
import AdminLayout from 'components/AdminLayout'

export interface AdminRoutesProps {}

function AdminRoutes({}: AdminRoutesProps) {
  return (
    <AdminLayout>
      <Switch>
        <AsyncRoute path='/dashboard' page='admin/Dashboard' />
        <AsyncRoute path='/users/:id' page='admin/UserDetail' />
        <AsyncRoute path='/users' page='admin/Users' />
        <AsyncRoute path='/subscriptions' page='admin/Subscriptions' />
        <AsyncRoute exact path='/plans' page='admin/Plans' />
        <AsyncRoute path='/templates/:name' page='admin/MailTemplateDetail' />
        <AsyncRoute path='/templates' page='admin/MailTemplates' />
        <AsyncRoute path='/requests' page='admin/Requests' />
        <Redirect to='/dashboard' />
      </Switch>
    </AdminLayout>
  )
}

export default AdminRoutes
